export const PLAN_PRICES = {
    ILLIMITED: {
        price: 149,
        discountPrice: 97,
    },
    ILLIMITED_PREMIUM: {
        price: 249,
        discountPrice: 169,
    },
};
function getNextJuneLastYear() {
    const now = new Date();
    const currentYear = now.getFullYear();
    const juneLastThisYear = new Date(currentYear, 5, 30);
    return now < juneLastThisYear ? currentYear : currentYear + 1;
}
export const policyMessages = {
    VIASTUD_30_1_MOIS: `{{first_price}}€ le 1er mois, puis {{monthly_price}}€ par mois jusqu’au 30 juin ${getNextJuneLastYear()}. Résiliation en un clic à tout moment. Renouvellement automatique à {{monthly_price}}€ par mois à partir du 1er juillet, sauf résiliation.`,
    VIASTUD_20_1_MOIS: '{{first_price}}€ le premier mois, puis {{monthly_price}}€ par mois, l’abonnement peut être résiliable à tout moment. La résiliation prendra effet à la fin de la période en cours, sans remboursement pour cette période.',
    VIASTUD_30: `{{first_price}}€ par mois, puis 99,83€ par mois jusqu’au 30 juin ${getNextJuneLastYear()}. Résiliation en un clic à tout moment. Renouvellement automatique à {{monthly_price}}€ par mois à partir du 1er juillet, sauf résiliation.`,
    BASE_COMMITMENT: `{{first_price}}€ le premier mois, puis {{monthly_price}}€ par mois jusqu'au 30 juin ${getNextJuneLastYear()}. Résiliation en un clic à tout moment. Renouvellement automatique à {{monthly_price}}€ par mois à partir du 1er juillet ${getNextJuneLastYear()}, sauf résiliation.`,
    BASE_NO_COMMITMENT: '{{monthly_price}}€ par mois, l’abonnement peut être résiliable à tout moment. La résiliation prendra effet à la fin de la période en cours, sans remboursement pour cette période.',
};
export function buildPolicyMessage(policyKey, replaceKeys) {
    let policyMessage = policyMessages[policyKey];
    for (const [key, value] of Object.entries(replaceKeys)) {
        policyMessage = policyMessage.replaceAll(`{{${key.trim()}}}`, value);
    }
    return policyMessage;
}
